import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    ProgressBar,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../exercises';
import {
    IllustrationBalancing,
    IllustrationDancing,
    IllustrationExamineThoughts,
    IllustrationThinking,
    Module3S2Exercise1Illustration5,
    Module3S2Exercise1Illustration6,
} from '../../icons';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData321: ExerciseData = {
    ExerciseView: Module3S2Exercise1,
    dataKeys: [],
    questions: [],
};

export function Module3S2Exercise1({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    return (
        <Exercise title="Afrunding af forløb">
            <ProgressBar current={exercise.CurrentPage} total={7} />
            <Page />
        </Exercise>
    );

    function Page() {
        switch (exercise.CurrentPage) {
            case 1:
                return (
                    <Page1
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.InProgress,
                                pageNumber: 2,
                            });
                        }}
                    />
                );
            case 2:
                return (
                    <Page2
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.InProgress,
                                pageNumber: 3,
                            });
                        }}
                    />
                );
            case 3:
                return (
                    <Page3
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.InProgress,
                                pageNumber: 4,
                            });
                        }}
                    />
                );
            case 4:
                return (
                    <Page4
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.InProgress,
                                pageNumber: 5,
                            });
                        }}
                    />
                );
            case 5:
                return (
                    <Page5
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.InProgress,
                                pageNumber: 6,
                            });
                        }}
                    />
                );
            case 6:
                return (
                    <Page6
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.InProgress,
                                pageNumber: 7,
                            });
                        }}
                    />
                );
            case 7:
                return (
                    <Page7
                        onContinue={() => {
                            onContinue({
                                status: ExerciseStatus.Completed,
                                goToNext: false,
                            });
                        }}
                    />
                );
        }
    }
}

type PageProps = {
    onContinue: () => void;
};

function Page1({ onContinue }: PageProps) {
    return (
        <div title="" className="clouds flex flex-1 flex-col">
            <Spacer />
            <LabelDisplay2 class="mb-10 text-center">Godt gået!</LabelDisplay2>
            <LabelBody class="mb-10 text-center">
                Du har nu været igennem dit forløb.
            </LabelBody>
            <LabelBody class="mb-10 text-center">
                Det er ikke sikkert, det har været nemt. Men nu står du her, på
                den anden side og har givet dig selv muligheden for at stå lidt
                stærkere.
            </LabelBody>
            <LabelBody class="mb-10 text-center">
                Du kan tage et kig tilbage og se på, hvad du har været igennem,
                og hvad du kan gøre, nu hvor dit forløb afrundes.
            </LabelBody>
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </div>
    );
}

function Page2({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Lad tanker være tanker</LabelDisplay2>
            <LabelBody>
                Du har lært forskellige ting. Blandt andet er du blevet fortalt,
                hvordan dine tanker og følelser er en del af det at være
                menneske. Og at selvom tankerne til tider kan blive negative og
                tunge, så har de ikke altid ret. I stedet for at se alle dine
                tanker som sandheder, kan de ses som sange, din indre dj
                spiller, fordi det er dens job at tilbyde en masse forskelligt.
                Nogle sange spilles oftere end andre, men du har mulighed for at
                overveje, om de er noget for dig.
            </LabelBody>
            <IllustrationDancing className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

function Page3({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Undersøg ubehaget</LabelDisplay2>
            <LabelBody>
                Tanker og følelser kommer og går, helt af sig selv, hvis du
                lader dem gøre det. Når man ikke er okay med en tanke eller
                følelse og prøver at undertrykke den eller løse den med det
                samme, så bliver det først hårdt arbejde. I stedet kan du tage
                dit blik lidt længere væk fra tankerne og følelserne og bare
                observere dem udefra, f.eks. som en biolog der på afstand er
                nysgerrig. På den måde er tankerne og følelserne stadig en del
                af dig, men uden at de fylder det hele og bliver styrende.
                Tankerne kan endda ses som sæbebobler, der svæver rundt og kan
                kigges på udefra eller bare svæve videre.
            </LabelBody>
            <IllustrationExamineThoughts className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

function Page4({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Flyt fokus fra tankerne</LabelDisplay2>
            <LabelBody>
                Men når man står der i momentet, og tankerne kører på højtryk,
                pulsen er høj - så kan det være svært at huske, at ens tanker
                bare er tanker, og man har måske brug for noget, der her og nu
                kan hjælpe en ud af hovedet. Der har du lært, at du kan bruge
                din krop. Den ved en masse og står klar til at hjælpe. F.eks.
                med en anderledes, dyb vejrtrækning og alle dine kropslige
                sanser.
            </LabelBody>
            <IllustrationThinking className="mx-auto my-30" />
            <LabelBody class="mb-30">
                Når du opdager, at du kun er i dit hoved, kan du spørge dig
                selv, hvor din krop mon er. Og så var der noget med, at det er
                helt normalt, og genkendeligt hos mange andre, at man kan blive
                noget selvkritisk overfor sig selv. Her er selvomsorgen, som den
                ser ud for dig, en værdifuld modvægt og et helt legitimt værktøj
                at bruge.
            </LabelBody>
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

function Page5({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Balancer din energi</LabelDisplay2>
            <LabelBody>
                Det seneste du har lært og overvejet er, hvordan du fordeler din
                energi og din tid. Både for at passe på dig selv men i
                særdeleshed også for at tage stilling til, hvilken form for
                hverdag DU ønsker og hvorfor. Det kan være værdifulde
                overvejelser, ikke kun som middel til at få ro på tankerne, men
                også for at blive klogere på dig selv som et helt menneske.
            </LabelBody>
            <IllustrationBalancing className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

function Page6({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">
                Realistiske tiltag i hverdagen
            </LabelDisplay2>
            <LabelBody className="mb-10">
                Og nu er du nået til vejs ende. Godt gået! Du har været igennem
                øvelser, video- og lydklip. Du har prøvet nogle ting af i din
                hverdag, og du kan måske gå med overvejelser om, hvilke andre
                redskaber som skal være en del af din fremtidige hverdag.
            </LabelBody>
            <LabelBody className="mb-10">
                En gennemgående pointe fra forløbet, som vi håber, at du vil
                tage med dig, er, at det altid er ét skridt ad gangen og små
                realistiske tiltag i din hverdag, der kan gøre en forskel på
                lang sigt.
            </LabelBody>
            <Module3S2Exercise1Illustration5 className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

function Page7({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Hvad sker der nu?</LabelDisplay2>
            <LabelBody class="mb-10">
                At bruge teknikkerne i din hverdag er som nævnt, noget der
                kræver tid. Hvis de konkrete øvelser har givet mening for dig,
                har du i den næste periode mulighed for at bruge appen, og det
                indhold der er.
            </LabelBody>
            <LabelBody>
                Du vil have adgang til appen de næste seks måneder.
            </LabelBody>
            <Module3S2Exercise1Illustration6 className="mx-auto my-30" />
            <LabelBody class="mb-30">
                Husk, at du aldrig behøver være alene om at have det svært. Der
                er altid hjælp og støtte at hente. Fra folk omkring dig og fra
                fagprofessionelle, hvis du oplever behov for det.
            </LabelBody>
            <Spacer />
            <SecondaryButton onClick={onContinue}>Afslut</SecondaryButton>
        </>
    );
}
